import { AaoLens, SmartForm, TranslationService, WebHosting, PartnerZliu, PartnerExcellus, PartnerInnovativeJourney } from "./components/Icons";
import { AaoLens as MobileAaoLens, SmartForm as MobileSmartForm, TranslationService as MobileTranslationService, WebHosting as MobileWebHosting, PartnerZliu as MobilePartnerZliu, PartnerExcellus as MobilePartnerExcellus, PartnerInnovativeJourney as MobilePartnerInnovativeJourney } from "./components/MobileIcon";



export default {
    menuData: [
        {
            "idx": 0,
            "title": "Company",
            "path": "/"
        },
        {
            "idx": 1,
            "title": "Products",
            "path": "/products",
            "children": [
                {
                    "idx": 0,
                    "title": "RB Translation Service",
                    "path": "/translation-service"
                },
                {
                    "idx": 1,
                    "title": "AAO Lens",
                    "path": "/products/aaolens"
                },
                {
                    "idx": 2,
                    "title": "Web Hosting Service",
                    "path": "/webhosting-service"
                },
                {
                    "idx": 3,
                    "title": "RB SmartForm",
                    "path": "/products#smartform"
                }
            ]
        },
        {
            "idx": 2,
            "path": "/careers",
            "title": "Careers",
        }
    ],
    portal: {
        label: "Login to Customer Portal",
        link: "https://platform.roundblock.io/"
    },
    home: {
        title:["Navigating the Future of","Advanced Technologies"],
        subTitle: "Quality Legal Service powered with AI",
        contactUsBtnLabel: "Contact us ",
        contactFormTitle: 'CONTACT',
        contactFormSubtitle: ['San Francisco Bay Area, CA 95014', 'info@roundblock.io']
    },
    products: {
        pageTitle: "Our Products",
        pageSubTitle: "Explore what Roundblock builds — from AI-assisted legal tools to the infrastructure that keeps your business running.",
        items: [
            {
                slug: "translation-service",
                title: "RB Translation Service",
                tagline: "High-quality document translation with preserved formatting",
                description: "Fast, accurate translation for legal and business documents, powered by AI and reviewed by specialists, with layouts, tables, and formatting kept intact.",
                capabilities: [
                    "Multi-language document translation",
                    "Format-preserving output (PDF, Word, and more)",
                    "AI-assisted with human quality review",
                    "Fast turnaround for legal & business documents"
                ],
                icon: <TranslationService width={74} height={74}/>,
                mobileIcon: <MobileTranslationService width={46} height={46}/>,
                cta: { label: "Learn More", type: "page", link: "/translation-service" }
            },
            {
                slug: "aao-lens",
                title: "AAO Lens",
                tagline: "AI-powered insight for AAO case review",
                description: "AAO Lens helps legal teams analyze Administrative Appeals Office decisions faster, surfacing relevant precedent and patterns to strengthen case strategy.",
                capabilities: [
                    "AAO decision search & analysis",
                    "Pattern and precedent detection",
                    "AI-assisted case insights",
                    "Built for immigration legal teams"
                ],
                icon: <AaoLens width={74} height={74}/>,
                mobileIcon: <MobileAaoLens width={46} height={46}/>,
                cta: { label: "Learn More", type: "page", link: "/products/aaolens" }
            },
            {
                slug: "web-hosting",
                title: "Web Hosting Service",
                tagline: "Reliable, managed hosting for your business",
                description: "Secure, scalable web hosting with hands-on support, so your site stays fast and available without the operational overhead.",
                capabilities: [
                    "Managed hosting & maintenance",
                    "Security monitoring & backups",
                    "Scalable infrastructure",
                    "Dedicated support"
                ],
                icon: <WebHosting width={74} height={74}/>,
                mobileIcon: <MobileWebHosting width={46} height={46}/>,
                cta: { label: "Learn More", type: "page", link: "/webhosting-service" }
            },
            {
                slug: "smartform",
                title: "RB SmartForm",
                tagline: "Smarter forms for faster intake",
                description: "RB SmartForm streamlines data collection with intelligent, dynamic forms that reduce errors and speed up client intake and processing.",
                capabilities: [
                    "Dynamic, conditional form logic",
                    "Built-in validation",
                    "Faster client intake",
                    "Integrates with your workflow"
                ],
                icon: <SmartForm width={74} height={74}/>,
                mobileIcon: <MobileSmartForm width={46} height={46}/>,
                cta: { label: "Get Started", type: "contact", link: "/" }
            }
        ],
        welcomeTitle: "Let's work with us",
        welcomeSubTitle: "Check our new openings."
    },
    translationService: {
        title: "RB Translation Service",
        subTitle: "Human-vetted document translation — accurate, format-preserving, and back in your hands within 48 hours.",
        intro: "Legal filings, contracts, and business documents translated with AI assistance and reviewed line by line by specialists, so terminology, layout, tables, and formatting survive the trip.",
        heroCtaLabel: "Request a Quote",
        highlights: {
            title: "What You Get",
            items: [
                {
                    title: "Human-Vetted Quality",
                    text: "Every translation is reviewed by a specialist before delivery — no raw machine output."
                },
                {
                    title: "Format Preserved",
                    text: "PDF, Word, and scanned layouts come back with tables, headers, and pagination intact."
                },
                {
                    title: "48-Hour Turnaround",
                    text: "Standard documents are returned within 48 hours of approved payment."
                },
                {
                    title: "Built for Legal Work",
                    text: "Terminology consistency for filings, contracts, evidence packets, and supporting exhibits."
                }
            ]
        },
        flow: {
            title: "How to Request",
            subTitle: "Five steps from your document to a delivered translation.",
            steps: [
                {
                    title: "Send Your Document",
                    text: "Email your file to",
                    email: "info@roundblock.io"
                },
                {
                    title: "Receive a Quote",
                    text: "We review scope, language pair, and turnaround, then send a written quote."
                },
                {
                    title: "Approve the Quote",
                    text: "Reply to confirm the quote and we schedule your document with a linguist."
                },
                {
                    title: "Make Payment",
                    text: "Settle the invoice using the payment link included with your approved quote."
                },
                {
                    title: "Get Your Translation",
                    text: "The RB team returns a human-vetted, high-quality translation within 48 hours."
                }
            ]
        },
        cta: {
            title: "Ready to Get Started",
            subTitle: "Send us your document and we will come back with a quote.",
            label: "Request a Quote",
            email: "info@roundblock.io"
        },
        modal: {
            title: "Request a Translation Quote",
            subTitle: "Tell us what you need translated and we will come back with a quote.",
            submitLabel: "Send Request",
            submittingLabel: "Sending...",
            success: "Request Sent",
            fail: "Something went wrong. Please try again, or email us at info@roundblock.io.",
            successNote: "We will come back with a quote shortly. To speed things up, send your document to",
            email: "info@roundblock.io",
            fields: {
                name: "Name",
                email: "Email",
                languages: "Languages",
                languagesPlaceholder: "e.g. Spanish to English",
                deadline: "Deadline",
                deadlinePlaceholder: "e.g. within 48 hours",
                details: "Details",
                detailsPlaceholder: "Document type, page count, and anything else we should know."
            }
        }
    },
    webhosting: {
        pageTitle: "Web Hosting Service",
        pageSubTitle: "Custom-built websites for small and mid-sized businesses — designed around how you actually work, and kept current by your own team.",
        heroCtaLabel: "Talk to us",
        pitch: {
            title: "Built for small and mid-sized businesses",
            paragraphs: [
                "Most small firms are stuck choosing between a template that looks like everyone else's and an agency retainer they don't need. We sit in between: a site shaped around your services, your intake process, and the clients you want to reach.",
                "Every site we build is custom. We start from your content rather than a theme — page structure, layout, and wording are designed for your business, then handed over ready to run."
            ]
        },
        highlight: {
            eyebrow: "Update in plain language",
            title: "Your team updates the site by describing the change",
            description: "No CMS training, no HTML, no waiting on a developer. A staff member writes what they want changed in their own words, sees a preview, and publishes when it looks right.",
            examples: [
                "Add Maria to the attorneys page",
                "Update the office hours for the holidays",
                "Put the new H-1B article on the homepage"
            ],
            points: [
                "Describe the change the way you'd say it out loud",
                "Preview every edit before it goes live",
                "Changes are versioned and can be rolled back",
                "Routine updates need no developer at all"
            ]
        },
        capabilities: {
            title: "What's included",
            subTitle: "Design, hosting, and day-to-day upkeep in one service.",
            items: [
                {
                    title: "Custom design and build",
                    description: "Layout, structure, and copy are built around your services and the way clients find you — not adapted from a theme."
                },
                {
                    title: "Plain-language editing",
                    description: "Staff describe the change they want. The edit is drafted, previewed, and published without touching code."
                },
                {
                    title: "Bilingual pages",
                    description: "English and Chinese versions kept in sync, with translation handled as part of the service."
                },
                {
                    title: "Managed hosting",
                    description: "Domains, certificates, backups, and uptime monitoring are handled for you. Nothing to maintain."
                },
                {
                    title: "Fast on every device",
                    description: "Pages are built to load quickly and read well on phones, where most prospective clients first find you."
                },
                {
                    title: "Search and intake ready",
                    description: "Clean page structure, metadata, and contact forms that route enquiries to the right person on your team."
                }
            ]
        },
        partners: {
            title: "Firms we host",
            subTitle: "A selection of the immigration practices whose sites we design, host, and maintain.",
            linkLabel: "Visit site",
            items: [
                {
                    slug: "zliulaw",
                    name: "Z Liu Law Group",
                    practice: "Immigration law",
                    tagline: "Your Pathway to a New Beginning",
                    url: "https://www.zliulaw.com/",
                    icon: <PartnerZliu width={101} height={40}/>,
                    mobileIcon: <MobilePartnerZliu width={101} height={40}/>
                },
                {
                    slug: "excelluslaw",
                    name: "Excellus Law",
                    practice: "Immigration law",
                    tagline: "",
                    url: "https://www.excelluslaw.com/",
                    icon: <PartnerExcellus width={44} height={44}/>,
                    mobileIcon: <MobilePartnerExcellus width={44} height={44}/>
                },
                {
                    slug: "innovativejourneylaw",
                    name: "Innovative Journey Law Group",
                    practice: "Immigration law",
                    tagline: "Navigate Your Immigration Journey with Confidence",
                    url: "https://www.innovativejourneylaw.com/en",
                    icon: <PartnerInnovativeJourney width={48} height={48}/>,
                    mobileIcon: <MobilePartnerInnovativeJourney width={48} height={48}/>
                }
            ]
        },
        welcomeTitle: "Let's build your site",
        welcomeSubTitle: "Tell us about your firm and we'll show you what your site could look like.",
        welcomeBtnLabel: "Contact us"
    },
    aaoLens: {
        pageTitle: "AAO Lens",
        pageSubTitle: "Natural-language search over 28,000+ USCIS AAO non-precedent decisions. Every answer cites the decisions it relies on and links straight to the USCIS PDF, so you can check it before you file.",
        heroCtaLabel: "Get Started",
        heroCtaLink: "https://aaolens.roundblock.io",
        pitch: {
            title: "Built for immigration lawyers",
            paragraphs: [
                "AAO Lens searches the Administrative Appeals Office record — 28,000+ non-precedent decisions on immigration petitions and waivers, from 2015 to the present. You ask the question you would ask a colleague, in your own words, and the answer is written from the decisions the search actually returned.",
                "AAO decisions are non-precedent: persuasive, never binding. That is exactly why the citation matters more than the summary. Every answer names the decisions behind it — decided date, form type, USCIS category, outcome — and links to the USCIS PDF, so what you rely on is the document itself."
            ]
        },
        highlight: {
            eyebrow: "Ask in plain English",
            title: "Ask the question the way you would ask a colleague",
            description: "No boolean strings, no citation syntax, no guessing at keywords. Follow up in the same conversation when the answer raises the next question, and attach the file you are working from so those follow-ups stay anchored to your case.",
            examples: [
                "What does Dhanasar require for a national interest waiver?",
                "How does the AAO treat extreme hardship in 212(i) waiver cases?",
                "What must a petitioner show for the original-contributions criterion?"
            ],
            points: [
                "Follow-up questions keep the earlier context intact",
                "Attach an RFE, a denial, or supporting evidence — PDF, image, or .docx",
                "An attachment stays attached for the rest of the conversation",
                "Narrow to the last two years, the last five, or search all of them",
                "Filter by USCIS category from the terms lawyers use — NIW, EB-1A — with all 65 codes one click away",
                "Set how many decisions an answer may cite: 5, 10, or 15"
            ]
        },
        flow: {
            title: "What happens when you ask",
            subTitle: "Five steps between your question and an answer you can check — and you watch each one as it runs.",
            steps: [
                {
                    title: "It reads your question",
                    text: "Plain English in. AAO Lens works out what you are actually asking before it searches for anything."
                },
                {
                    title: "It searches the record",
                    text: "Your question runs against 28,000+ AAO non-precedent decisions, inside whatever date range and categories you set."
                },
                {
                    title: "It ranks what it found",
                    text: "Matching decisions are ordered by relevance and by recency, so the most on-point and most current surface first."
                },
                {
                    title: "It reads the decisions",
                    text: "The decisions it selected are read in full, and the answer is written from the passages it used — streaming to you as it goes."
                },
                {
                    title: "It checks its own citations",
                    text: "Every decision an answer cites is checked against the decisions actually retrieved. A citation that does not hold up triggers a second attempt, and if it fails again the answer is withheld rather than shown with a caveat."
                }
            ]
        },
        capabilities: {
            title: "What you get",
            subTitle: "Every claim in an answer traces back to a decision you can open yourself.",
            items: [
                {
                    title: "Citations under every answer",
                    description: "Each answer lists the decisions it drew on: title, decided date, form type, USCIS category and code, outcome, and the passages it used."
                },
                {
                    title: "Straight to the USCIS PDF",
                    description: "A citation links to the decision on USCIS — the original document, not a summary of it. Read the paragraph yourself before you rely on it."
                },
                {
                    title: "Citations verified, not assumed",
                    description: "Cited decisions are checked against what the search returned. If one cannot be matched, the answer is rewritten, and if it still fails it is discarded rather than shown to you."
                },
                {
                    title: "It declines rather than guesses",
                    description: "When the search comes back thin, AAO Lens says so instead of filling the gap. Questions outside the AAO record are turned down outright."
                },
                {
                    title: "Filters shaped by the work",
                    description: "Limit the years, cap how many decisions an answer may cite, and filter by USCIS category from a practitioner shortlist rather than a list of 65 codes."
                },
                {
                    title: "One corpus, one job",
                    description: "AAO non-precedent decisions, 2015 to the present, and nothing else. The scope is enforced in the product, not left to a disclaimer."
                }
            ]
        },
        welcomeTitle: "Ask your first question",
        welcomeSubTitle: "AAO Lens runs in the browser and signs in with your RoundBlock account.",
        welcomeBtnLabel: "Get Started"
    },
    careers: {
        title: "JOIN US!",
        subTitle: "We Have Following Openings",
        jobboxTitle: "Forward Together",
        joboxSubTitle: "Please send your resume to hiring@roundblock.io for applications.",
        jobs: [
            {
                title: "Front End Engineer",
                description: "You'll be responsible for developing responsive, robust, and visually striking interfaces that engage and delight users."
            },
            {
                title: "UI/UX Intern",
                description: "This role offers a unique opportunity to shape the user experience from the ground up, all while learning from industry experts in a dynamic, fast-paced environment."
            },
            {
                title: "AI Research Scientist",
                description: "A strong candidate will have a deep understanding of machine learning, neural networks, and computational statistics, with a passion for innovation and a track record of published research"
            }
        ]
    },
    footer: {
        company: {
            title: "© 2026 Roundblock Technology LLC. All rights reserved."
        },
        legal: {
            items: [
                {
                    "title": "Terms of Use",
                    "link": "/terms"
                },
                {
                    "title": "Privacy Statement",
                    "link": "/privacy"
                }
            ]
        },
        products: {
            title: "Products",
            items: [
                {
                    "title":"RB Translation Service",
                    "link": "/translation-service"
                },
                {
                    "title":"AAO Lens",
                    "link": "/products/aaolens"
                },
                {
                    "title":"Web Hosting Service",
                    "link": "/webhosting-service"
                },
                {
                    "title":"RB SmartForm",
                    "link": "/products#smartform"
                }
            ]
        },
        contactus: {
            title: "Contact us",
            items: [
                "info@roundblock.io"
            ]
        },
        address: {
            title: "Address",
            items: [
                "3400 Cottage Way, Ste G2  #14254",
                "sacramento, California, 95825"
            ]
        }
    },
    contactUs: {
        success: "Your information has been submitted successfully.",
        fail: "Please try again."
    },
    privacy: {
        title: "Roundblock Privacy Statement",
        updated: "Last Updated: 10/27/2024",
        intro: "Roundblock Technology is committed to protecting the privacy and security of our users. This Privacy Statement explains how we collect, use, disclose, and safeguard your information when you use our applications and services, including any media, software, features, web services, or information provided on or through it.",
        sections: [
            {
                title: "Information We Collect",
                blocks: [
                    {
                        subtitle: "Information You Provide to Us",
                        items: [
                            "Personal Identifiers: This may include your name, email address, and other contact information you provide when using our services.",
                            "Content You Generate or Provide: Information and content you create or provide while using our services, including queries to the GPT model and responses generated."
                        ]
                    },
                    {
                        subtitle: "Information Collected Automatically",
                        items: [
                            "Usage Information: Details of your interactions with our services, including the types of content you view or engage with, the features you use, and the actions you take.",
                            "Device Information: We may collect information about the devices you use to access our services, including hardware models, operating systems, and unique device identifiers."
                        ]
                    }
                ]
            },
            {
                title: "How We Use Your Information",
                blocks: [
                    {
                        subtitle: "",
                        text: "We use your information for the following purposes:",
                        items: [
                            "To provide, maintain, and improve our services, including to personalize your experience.",
                            "To understand how our services are used and to help us improve user experience and customer satisfaction.",
                            "To communicate with you, including to respond to your inquiries and fulfill your requests."
                        ]
                    }
                ]
            },
            {
                title: "Sharing Your Information",
                blocks: [
                    {
                        subtitle: "",
                        text: "We do not share your personal information with third parties except:",
                        items: [
                            "To comply with legal obligations or to respond to legal proceedings.",
                            "To protect the rights, property, or safety of Roundblock Technology, our users, or others.",
                            "With your consent or at your direction."
                        ]
                    }
                ]
            },
            {
                title: "Data Security",
                blocks: [
                    {
                        subtitle: "",
                        text: "We implement a variety of security measures designed to maintain the safety of your personal information when you use our services. However, no security measures are perfect or impenetrable, and we cannot guarantee the security of your personal information.",
                        items: []
                    }
                ]
            },
            {
                title: "Data Retention",
                blocks: [
                    {
                        subtitle: "",
                        text: "We retain your personal information for as long as necessary to provide the services you have requested and thereafter for a variety of legitimate legal or business purposes.",
                        items: []
                    }
                ]
            },
            {
                title: "Your Rights",
                blocks: [
                    {
                        subtitle: "",
                        text: "Depending on your location, you may have certain rights regarding your personal information, including the right to access, correct, or delete the information we hold about you.",
                        items: []
                    }
                ]
            },
            {
                title: "Changes to This Privacy Statement",
                blocks: [
                    {
                        subtitle: "",
                        text: "We may update our Privacy Statement from time to time. We will notify you of any changes by posting the new Privacy Statement on this page and updating the \"Last Updated\" date.",
                        items: []
                    }
                ]
            },
            {
                title: "Contact Us",
                blocks: [
                    {
                        subtitle: "",
                        text: "If you have any questions about this Privacy Statement, please contact us at info@roundblock.io",
                        items: []
                    }
                ]
            }
        ]
    },
    terms: {
        title: "Roundblock Terms and Conditions",
        updated: "Last Updated: 06/01/2026",
        intro: "",
        sections: [
            {
                title: "1. Acceptance of Terms",
                blocks: [
                    {
                        subtitle: "",
                        text: "These Terms and Conditions (\"Terms\") govern your use of the Roundblock Technology platform and services (the \"Service\"). By using our Service, you agree to comply with and be bound by these Terms. If you do not agree to these Terms, please refrain from using our Service.",
                        items: []
                    }
                ]
            },
            {
                title: "2. Description of the Service",
                blocks: [
                    {
                        subtitle: "",
                        text: "Roundblock Technology provides online platforms and applications that collect customer information to assist users with their requests. The Service aims to assist users in evaluating and processing their materials.",
                        items: []
                    }
                ]
            },
            {
                title: "3. User Eligibility",
                blocks: [
                    {
                        subtitle: "",
                        text: "To use the Service, you must be at least 18 years old. By using our Service, you affirm that you meet this eligibility requirement and that all information provided is accurate and complete.",
                        items: []
                    }
                ]
            },
            {
                title: "4. Privacy Policy",
                blocks: [
                    {
                        subtitle: "",
                        text: "Your use of the Service is also governed by our Privacy Statement. Please review the Privacy Statement to understand how we collect, use, and protect your personal information.",
                        items: []
                    }
                ]
            },
            {
                title: "5. User Conduct",
                blocks: [
                    {
                        subtitle: "",
                        text: "You agree not to:",
                        items: [
                            "Provide false or misleading information.",
                            "Violate any applicable laws or regulations.",
                            "Infringe on the intellectual property rights of others.",
                            "Interfere with the proper functioning of the Service.",
                            "Engage in any activity that could harm Roundblock Technology or its users."
                        ]
                    }
                ]
            },
            {
                title: "6. Data Collection and Usage",
                blocks: [
                    {
                        subtitle: "",
                        text: "By using our Service, you consent to the collection and use of your personal information as described in our Privacy Statement. We may use this information to provide and improve our Service.",
                        items: []
                    }
                ]
            },
            {
                title: "7. Service Fees",
                blocks: [
                    {
                        subtitle: "",
                        text: "Roundblock Technology may charge fees for certain services. Any fees and payment terms will be clearly communicated to you before you use the relevant service.",
                        items: []
                    }
                ]
            },
            {
                title: "8. Termination",
                blocks: [
                    {
                        subtitle: "",
                        text: "We reserve the right to terminate or suspend your access to the Service at our discretion, without notice, for any conduct that we believe violates these Terms or is harmful to other users or Roundblock Technology.",
                        items: []
                    }
                ]
            },
            {
                title: "9. Intellectual Property",
                blocks: [
                    {
                        subtitle: "",
                        text: "The content, design, and functionality of the Service are the exclusive property of Roundblock Technology. You may not use, reproduce, or distribute any content from the Service without our prior written consent.",
                        items: []
                    }
                ]
            },
            {
                title: "10. Limitation of Liability",
                blocks: [
                    {
                        subtitle: "",
                        text: "To the extent permitted by law, Roundblock Technology shall not be liable for any direct, indirect, incidental, consequential, or special damages arising out of or in any way connected with your use of the Service.",
                        items: []
                    }
                ]
            },
            {
                title: "11. Changes to Terms",
                blocks: [
                    {
                        subtitle: "",
                        text: "Roundblock Technology reserves the right to update or modify these Terms at any time without prior notice. Changes will be effective immediately upon posting on the website. It is your responsibility to review these Terms periodically.",
                        items: []
                    }
                ]
            },
            {
                title: "12. Contact Information",
                blocks: [
                    {
                        subtitle: "",
                        text: "If you have any questions or concerns about these Terms, please contact us at info@roundblock.io.",
                        items: []
                    }
                ]
            }
        ]
    }
}